import { Fab, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
    isProductionMovementCompleted,
    isStandardLob,
    showProductionMovementOption,
} from "../../services/userOnboardService/userOnboardService";
import { getMetaDataConfig } from "../../services/uiConfigService";
import ProductionMovementConfirmationPopup from "../../features/salescodeStudio/finalApp/popups/productionMovementConfirmationPopup";

const ProductionMovementFloaterIcon = (props: { isOnboarding: boolean, productionMovementStateChange: boolean | undefined }) => {
    const [showFloaterButton, setShowFloaterButton] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);

    useEffect(() => {
        (async () => {
            const portalConfig = await getMetaDataConfig(
                "clientConfig",
                "portal_configuration"
            );

            if (portalConfig &&
                isStandardLob(portalConfig) &&
                !isProductionMovementCompleted(portalConfig) && !props.isOnboarding && 
                showProductionMovementOption()
            ) {
                setShowFloaterButton(true);
            } else {
                setShowFloaterButton(false);
            }
        })();
    }, [props.isOnboarding, props.productionMovementStateChange]);

    return (
        <>
            {showFloaterButton === true && (
                <div
                    style={{
                        position: "fixed",
                        bottom: "30px",
                        right: "30px",
                    }}
                >
                    <Fab
                        onClick={() => {
                            setOpen(true);
                        }}
                        style={{
                            position: "relative",
                            width: "fit-content",
                            borderRadius: "15px",
                            padding: "10px",
                            backgroundColor: "#227c9d",
                            zIndex: 1,
                        }}
                    >
                        <Typography
                            sx={{
                                textAlign: "center",
                                color: "white",
                            }}
                        >
                            MOVE TO PRODUCTION
                        </Typography>
                    </Fab>
                </div>
            )}
            <ProductionMovementConfirmationPopup open={open} setOpen={setOpen} />
        </>
    );
};

export default ProductionMovementFloaterIcon;
